module.exports = __webpack_public_path__ + "static/media/main.033883a5.png";